var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:[_vm.$store.state.page === 'game' ? 'header--in-game' : false]},[_c('div',{staticClass:"header__wrapper"},[_c('div',{staticClass:"header-container"},[_c('Logo',{staticClass:"logo"}),_c('Navigation')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }